import {
    accountregister,
    logout
} from "@/api/user";
import {
    getToken,
    setToken,
    removeToken
} from '@/utils/auth'
const getDefaultState = () => {
    return {
        token: getToken() || '',
        TokenInfo: {}
    }
}
const state = getDefaultState()

const mutations = {
    setToken(state, newToken) {
        state.token = newToken
        console.log('登录带的token', state.token)

    },
    setTokenInfo(state, data) {
        state.TokenInfo = data
        console.log('登录带的info', state.TokenInfo)
    }
}
//准备actions——用于响应组件中的动作
const actions = {
    userLogin({
        commit
    }, userInfo) {
        return new Promise((resolve, reject) => {
            accountregister({
                account: userInfo.email,
                password: userInfo.password
            }).then(response => {
                if (response.code == 1) {
                    localStorage.setItem('userinfo', JSON.stringify(response.data.userinfo))
                    localStorage.setItem('token', response.data.userinfo.token)
                    console.log(response)
                    commit('setToken', response.data.userinfo.token)
                    commit('setTokenInfo', response.data.userinfo)
                    setToken(response.data.userinfo.token)
                }

                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    logout({
        commit,
        state
    }) {
        return new Promise((resolve, reject) => {
            logout().then(() => {
                console.log('tuichu')
                removeToken() // must remove  token  first
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // async userLogin(context, userInfo) {
    //     try {
    //         const res = await accountregister({
    //             account: userInfo.email,
    //             password: userInfo.password
    //         })
    //         //    localStorage.setItem('userinfo',JSON.stringify(res.data.userinfo) )
    //         //    localStorage.setItem('token',res.data.userinfo.token)
    //         // // 请求成功之后,保存token,所以调mutations函数
    //         commit('setToken', res.data.userinfo.token)
    //         commit('setTokenInfo', res.data.userinfo)
    //     } catch (err) {
    //         console.log(err)
    //     }

    // }

}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}